import React from 'react';

export const EsgFeedArrows = () => (
  <div>
    <img src="/images/templates/EsgFeedTableArrow.svg" alt="arrows" />
  </div>
);
